import { Count, Filters } from 'frontend/types'
import HorizontalFilterItems from './HorizontalFilterItems'
import styles from './HorizontalFilters.module.css'
import { SearchParams } from 'backend/services/types/urApiService.types'
import { FilterType } from 'frontend/enums'
import Format from './components/Format/Format'

interface Props {
  filters: Filters
  hiddenFilters?: FilterType[]
  searchParams: SearchParams
  updateSearch: (params: SearchParams, shouldReset?: boolean) => Promise<void>
  includeRelevance?: boolean
  count: Count
  filterSearchParams: SearchParams
  isChildPage?: boolean
}

const HorizontalFilters = ({
  filters,
  hiddenFilters,
  searchParams,
  updateSearch,
  includeRelevance,
  filterSearchParams,
  count,
  isChildPage = false,
}: Props) => {
  const executeSearch = async (
    params: SearchParams,
    shouldResetAllFilters = false,
  ) => {
    await updateSearch(params, shouldResetAllFilters)
  }

  return (
    <div className={styles.filterItemsWrapper}>
      <HorizontalFilterItems
        hiddenFilters={hiddenFilters || []}
        filters={filters}
        searchParams={searchParams}
        executeSearch={executeSearch}
        includeRelevance={includeRelevance}
      />

      {isChildPage && (
        <Format
          className={styles.setFormatRight}
          formats={filters.formats}
          count={count}
          searchParams={filterSearchParams}
          updateSearch={updateSearch}
        />
      )}
    </div>
  )
}

export default HorizontalFilters
